import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><clipPath id=\"pt_svg__radius\"><rect x=\"0\" y=\"1\" width=\"20\" height=\"18\" rx=\"4\" ry=\"4\"></rect></clipPath></defs><g clip-path=\"url(#pt_svg__radius)\"><rect y=\"1\" width=\"20\" height=\"18\" rx=\"4\" fill=\"#E84040\"></rect><rect y=\"1\" width=\"7\" height=\"18\" fill=\"#49B94D\"></rect><circle cx=\"7\" cy=\"10\" r=\"4\" fill=\"#FFD748\"></circle><path d=\"M5.5 8.5H8.5V10.5C8.5 11.3284 7.82843 12 7 12C6.17157 12 5.5 11.3284 5.5 10.5V8.5Z\" fill=\"white\" stroke=\"#E84040\"></path></g>", 2)
  ]))]))
}
export default { render: render }